<template>
    <div :class="['payment-result-page', 'payment-result-page--failed']">
        <div class="payment-result-card">
            <div class="payment-result-icon payment-result-icon--failed">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
            <div class="payment-result-title">{{ $t('common.billing.externalPaymentFailed') }}</div>
            <div v-if="errorMessage" class="payment-result-desc">{{ errorMessage }}</div>
            <div v-if="orderId" class="payment-result-order">#{{ orderId }}<template v-if="orderName"> &middot; {{ orderName }}</template></div>
            <button class="payment-result-btn" @click="goToPanel">{{ $t('common.billing.openBillingPanel') }}</button>
        </div>
    </div>
</template>

<script>
export default {
    layout: 'auth',
    computed: {
        orderId() {
            return this.$route.query.order_id || null
        },
        orderName() {
            return this.$route.query.order_name || null
        },
        errorMessage() {
            return this.$route.query.error || null
        },
    },
    methods: {
        goToPanel() {
            this.$router.push('/dashboard')
        },
    },
}
</script>

<style scoped>
.payment-result-page {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.payment-result-page--failed {
    background: linear-gradient(135deg, #FEF2F2 0%, #FECACA 50%, #FCA5A5 100%);
}

html.dark .payment-result-page--failed {
    background: linear-gradient(135deg, #1a0505 0%, #450a0a 50%, #7f1d1d 100%);
}

html.midnight .payment-result-page--failed {
    background: linear-gradient(135deg, #1a1510 0%, #2a1510 50%, #3a1a1a 100%);
}

.payment-result-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 48px 40px 36px;
    border-radius: 16px;
    max-width: 420px;
    width: 100%;
    background: #fff;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.1);
}

html.dark .payment-result-card {
    background: #1C1D22;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);
}

html.midnight .payment-result-card {
    background: #1E1B17;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.5);
}

.payment-result-icon {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    animation: resultShake 0.5s ease;
}

.payment-result-icon--failed {
    background: rgba(220, 38, 38, 0.1);
    color: #DC2626;
}

html.dark .payment-result-icon--failed,
html.midnight .payment-result-icon--failed {
    background: rgba(248, 113, 113, 0.12);
    color: #F87171;
}

.payment-result-title {
    font-size: 20px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 8px;
}

html.dark .payment-result-title {
    color: #F3F4F6;
}

html.midnight .payment-result-title {
    color: #F0E6D6;
}

.payment-result-desc {
    font-size: 13px;
    color: #6B7280;
    max-width: 300px;
    margin-bottom: 12px;
}

html.dark .payment-result-desc {
    color: #9CA3AF;
}

html.midnight .payment-result-desc {
    color: #A89880;
}

.payment-result-order {
    font-size: 13px;
    color: #6B7280;
    margin-bottom: 24px;
}

html.dark .payment-result-order {
    color: #9CA3AF;
}

html.midnight .payment-result-order {
    color: #A89880;
}

.payment-result-btn {
    padding: 10px 28px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: all 0.15s;
    background: #DC2626;
    color: #fff;
}

.payment-result-btn:hover {
    background: #B91C1C;
}

html.dark .payment-result-btn,
html.midnight .payment-result-btn {
    background: #EF4444;
}

html.dark .payment-result-btn:hover,
html.midnight .payment-result-btn:hover {
    background: #DC2626;
}

@keyframes resultShake {
    0%, 100% { transform: translateX(0); }
    15% { transform: translateX(-8px); }
    30% { transform: translateX(8px); }
    45% { transform: translateX(-6px); }
    60% { transform: translateX(6px); }
    75% { transform: translateX(-3px); }
    90% { transform: translateX(3px); }
}
</style>
